import React, { useState } from 'react';
import { db, auth } from '../../api';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Navigate, Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import {
  Heading,
  Button,
  Box,
  Text,
  TableContainer,
  Table,
  Thead,
  Tr,
  Td,
  Th,
  Tbody,
  VStack,
} from '@chakra-ui/react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomDatePicker from '../../components/CustomDatePicker';
import { collection, query, where, getDocs } from 'firebase/firestore';

const loadStats = async (from, to) => {
  const querySnapshot = await getDocs(
    query(
      collection(db, 'order'),
      where('selectedDate', '>=', new Date(from)),
      where('selectedDate', '<', new Date(to)),
    ),
  );

  const emailCounts = {};

  // Analizza i documenti
  querySnapshot.forEach((doc) => {
    const settledBy = doc.data().settledBy;

    if (settledBy && Array.isArray(settledBy)) {
      settledBy.forEach((email) => {
        emailCounts[email] = (emailCounts[email] || 0) + 1;
      });
    }
  });

  return emailCounts;
};

function OperatorsStats() {
  const [from, setFrom] = useState(new Date(new Date().setHours(0, 0, 0, 0)));
  const [to, setTo] = useState(new Date());
  const [emailCounts, setEmailCounts] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const isDisabled = from > to;

  const loadStatsHandler = async () => {
    setIsLoading(true);
    const emailCounts = await loadStats(from, to);
    setEmailCounts({ ...emailCounts });
    setIsLoading(false);
  };

  // COPY PASTE ON ALL PROTECTED ROUTES
  const [user] = useAuthState(auth);
  if (!user || user.displayName !== 'admin') return <Navigate to='/dashboard' replace={true} />;

  return (
    <VStack w='100%'>
      <Heading mt={5} mb={0} color={'white'}>
        Statistiche Operatori
      </Heading>

      <Text mb={3}>{process.env.REACT_APP_PROJECT_ID}</Text>
      <Button mb={3} as={Link} to='/dashboard'>
        Dashboard
      </Button>
      <Box w='100%' border={'3px solid teal'} borderRadius={15} p={5} my={10} color='white'>
        <Text fontSize={'lg'} fontWeight={600} mb={5}>
          Da
        </Text>
        <DatePicker
          showTimeSelect
          dateFormat='MMMM d, yyyy H:mm'
          showPopperArrow={false}
          selected={from}
          onChange={(_date) => {
            setFrom(_date);
          }}
          customInput={<CustomDatePicker />}
        />
        <Text fontSize={'lg'} fontWeight={600} my={5}>
          A
        </Text>
        <DatePicker
          showTimeSelect
          dateFormat='MMMM d, yyyy H:mm'
          showPopperArrow={false}
          selected={to}
          onChange={(_date) => {
            setTo(_date);
          }}
          customInput={<CustomDatePicker />}
        />
        <Button
          mt={5}
          isLoading={isLoading}
          isDisabled={isDisabled}
          onClick={() => {
            loadStatsHandler();
          }}
        >
          Carica
        </Button>
        {Object.keys(emailCounts).length === 0 && <Text my={20}>Non ci sono statistiche per questo periodo.</Text>}
        {Object.keys(emailCounts).length !== 0 && (
          <TableContainer border={'3px solid teal'} borderRadius={15} p={5} my={10}>
            <Table variant='striped'>
              <Thead>
                <Tr>
                  <Th>Email</Th>
                  <Th isNumeric>Ordini Smarcati</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Object.entries(emailCounts).map(([email, count]) => (
                  <Tr key={email}>
                    <Td>{email}</Td>
                    <Td isNumeric>{count}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
        <Footer />
      </Box>
    </VStack>
  );
}
export default OperatorsStats;
